import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import "./HRbutton.css";
import BotGif from "../../../../assets/gif/bot.gif";
import Bot from "../../../../assets/gif/bot-img.png"


const POPS   = ["✨","💼","🚀","🎯","💡","🌟","💬"];
const REPEAT = 10000; // greeter re-appears every 10s when popup is closed

export default function HRButton() {
  const [cardVisible,  setCardVisible]  = useState(false);
  const [showBadge,    setShowBadge]    = useState(true);
  const [showGreeter,  setShowGreeter]  = useState(false);
  const [pops,         setPops]         = useState([]);
  const greeterTimer  = useRef(null);
  const navigate      = useNavigate();
  const location = useLocation();

  /* ── helpers ── */
  const spawnPops = useCallback(() => {
    const next = POPS.map((emoji, i) => ({
      id: Date.now() + i, emoji,
      x: Math.random() * 70 - 35,
      delay: i * 0.11,
    }));
    setPops(next);
    setTimeout(() => setPops([]), 2200);
  }, []);

  /* ── greeter peek cycle ── */
const peekGreeter = useCallback(() => {
  if (cardVisible || location.pathname === "/employee/hrtalk") return;
  setShowGreeter(true);
  setTimeout(() => setShowGreeter(false), 6000);
}, [cardVisible, location.pathname]);

  useEffect(() => {
    // first peek after 1.2 s
    const init = setTimeout(peekGreeter, 1200);
    // then every REPEAT ms
    greeterTimer.current = setInterval(peekGreeter, REPEAT);
    return () => { clearTimeout(init); clearInterval(greeterTimer.current); };
  }, [peekGreeter]);

  /* ── scroll trigger every 10 sections ── */
  const scrollCount = useRef(0);
  useEffect(() => {
    const onScroll = () => {
      const scrolled = Math.floor(window.scrollY / 800);
      if (scrolled > scrollCount.current && scrolled % 10 === 0) {
        scrollCount.current = scrolled;
        if (!cardVisible) {
          setShowBadge(true);
          setCardVisible(true);
          spawnPops();
        }
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [cardVisible, spawnPops]);

  /* ── FAB click ── */
  function handleFab() {
    setShowBadge(false);
    setShowGreeter(false);
    if (!cardVisible) spawnPops();
    setCardVisible(v => !v);
  }

  return (
    <div className="ct-root">

      {/* floating emoji pops */}
      <div className="ct-pops-wrap">
        {pops.map(p => (
          <span key={p.id} className="ct-pop"
            style={{ left: p.x + "px", animationDelay: p.delay + "s" }}>
            {p.emoji}
          </span>
        ))}
      </div>

      {/* greeter peek — gif + speech bubble */}
{showGreeter && !cardVisible && location.pathname !== "/employee/hrtalk" && (
  <div className="ct-greeter">
    
    <div 
      className="ct-greeter-bubble"
      onClick={() => navigate("/employee/hrtalk")}
    >
      👋 Need career help?
    </div>

    <img 
      src={BotGif} 
      alt="HR bot" 
      className="ct-greeter-gif"
      onClick={() => navigate("/employee/hrtalk")}
    />
    
  </div>
)}

      {/* popup card */}
      {cardVisible && (
        <div className="ct-card">
          {/* dark header */}
          <div className="ct-card-header">
            <button className="ct-card-close" onClick={() => setCardVisible(false)}>×</button>
            <div className="ct-card-avatar-row">
              <div className="ct-card-avatar"
                style={{ background: "black" }}>
                <img src={BotGif} alt="bot" />
              </div>
              <div>
                <p className="ct-card-avatar-name">HR Expert</p>
                <p className="ct-card-avatar-role">Career Consultant</p>
              </div>
            </div>
            <div className="ct-card-online">
              <span className="ct-card-online-dot" />
              3 experts online now
            </div>
          </div>

          {/* body */}
          <div className="ct-card-body">
            <div className="ct-card-bubble">
              Hi! I can help with salary negotiation, interview prep, and career planning. Let's talk 👋
            </div>
            <div className="ct-card-tags">
              <span className="ct-card-tag">Salary tips</span>
              <span className="ct-card-tag">Interview prep</span>
              <span className="ct-card-tag">Career switch</span>
            </div>
            <button className="ct-card-btn"
              onClick={() => { setCardVisible(false); navigate("/employee/hrtalk"); }}>
              Talk to HR now
              <span className="ct-card-btn-arrow">→</span>
            </button>
          </div>
        </div>
      )}

      {/* FAB */}
  <div className="ct-fab-wrap">
  <span className="ct-pulse" />
  <span className="ct-pulse" style={{ animationDelay: "1.1s" }} />
  {showBadge && <span className="ct-badge">1</span>}
  <button className="ct-fab" onClick={handleFab}>
    <img src={Bot} alt="bot" className="ct-fab-gif" />
  </button>
</div>

    </div>
  );
}